/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

export default function Mission({ data }) {
  return (
    <section className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
      <div className="max-w-6xl mx-auto">
        <div className="mission-section">
          <div>
            <span className="section-eyebrow">About Web7Labs</span>
            <h2 className="mission-heading mt-4">{data.heading}</h2>
            <p className="mission-body">{data.body}</p>
            <h3 className="mission-subheading">{data.approachHeading}</h3>
            <p className="mission-body">{data.approachBody}</p>
          </div>
          <div className="mission-image">
            <img src={data.imageUrl} alt="Our team collaborating" />
          </div>
        </div>
      </div>
    </section>
  );
}
